<script setup>
    import { computed } from "vue"

    const props = defineProps({
        dark: {
            type: Boolean,
            default: false,
        },
        height: {
            type: String,
            default: "100px",
        },
    })

    const logo_path = computed(() => {
        return props.dark ? "/logo-white.svg" : "/Fichier.svg"
    })
</script>

<template>
    <div>
        <v-img
            :height="height"
            :src="logo_path"
            contain="true"
            v-bind="$attrs"
        />
    </div>
</template>

<!--<script>-->
<!--export default {-->
<!--    props: {-->
<!--        dark: Boolean,-->
<!--        height: String,-->
<!--    },-->
<!--    computed: {-->
<!--        logo_path() {-->
<!--            if (this.dark || this.$vuetify.theme.dark) {-->
<!--                return "/logo-white.svg"-->
<!--            }-->
<!--            return "/Fichier.svg"-->
<!--        },-->
<!--    },-->
<!--}-->
<!--</script>-->
